import {useEffect} from 'react';

export const useBlockScroll = (visible: boolean) => {
  useEffect(() => {
    if (visible) {
      // Désactive le défilement
      document.body.style.overflow = 'hidden';

      // Restaure le style original quand la modale se ferme
      return () => {
        document.body.style.overflow = 'unset';
      };
    }

    return undefined;
  }, [visible]);
};
